import * as React from 'react';

import { useAuth } from '../../contexts/auth/useAuth';
import { IUser } from '../../api/models/IUser';
import { hasPermission, TPermission } from '../../api/Permission';

interface ICanProps {
  /** @ignore */
  children?: React.ReactNode;
  /** Permission to check. */
  permission: TPermission;
}

/**
 * Returns true if IAuth's roles matches one or more of the input roles,
 * false if not.
 */
const can = (auth: IUser, permission: TPermission): boolean => {
  return hasPermission(auth.roles, permission);
}

/**
 * Renders its children only if the current user's roles allow the specified
 * permssion.
 */
const Can = (props: ICanProps) => {
  const auth = useAuth();

  if (!auth) return null;

  const allowed = hasPermission(auth.user?.roles, props.permission);

  return allowed ? <>{props.children}</> : null;
};

export { Can, can }
